import { Menu, Modal } from 'antd';
import { useLocation, useNavigate } from 'react-router';

import { LogoutOutlined } from '@ant-design/icons';

import { useAppDispatch, useAppSelector } from '../../hooks';
import { useCapturePostHog } from '../../hooks/useCapturePostHog';
import { logout } from '../pages/Login/authSlice';
import { getSideMenuItems } from './layout.helper';

export const SideNavMenu = () => {
  const { capturePostHogCustomEvent } = useCapturePostHog();
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname.split('/page')[1];
  const dispatch = useAppDispatch();
  const currentUser = useAppSelector((state) => state.authSlice.currentUser);
  const authResult = useAppSelector((state) => state.authSlice.authResult);
  const missedScheduledProductCount = useAppSelector(
    (state) => state.scheduledProductsSlice.missedScheduledProductCount,
  );

  const logoutPrompt = () => {
    Modal.confirm({
      title: 'Log out',
      icon: <LogoutOutlined />,
      content: 'Are you sure you want to log out?',
      okText: 'Yes',
      cancelText: 'Cancel',
      onOk: () => {
        navigate('/login');
        capturePostHogCustomEvent('LogoutPrompt logged out');
        dispatch(logout());
      },
      onCancel: () => {
        capturePostHogCustomEvent('LogoutPrompt close modal');
      },
    });
  };

  return (
    <Menu
      style={{ marginTop: 15, borderRight: 0 }}
      selectedKeys={[path]}
      theme="light"
      mode="inline"
      items={getSideMenuItems(currentUser, authResult, missedScheduledProductCount)}
      onSelect={({ key }) => {
        if (key === '/logout') {
          logoutPrompt();
        } else {
          navigate(`/page${key}`);
        }
      }}
    />
  );
};
